<template>
    <div
        ref="autocomplete"
        class="autocomplete"
        :class="[
            `autocomplete-${size}`,
            {
                'position-inherit': showOverflow
            },
            {
                'position-relative': selectedResult || !showOverflow
            }
        ]"
    >
        <slot>
            <input 
                :id="id" 
                type="text" 
                autocomplete="off" 
                class="form-control" 
                :placeholder="placeholder" 
                :disabled="disabled"
                :class="[`form-control-${size}`]"
            />
        </slot>
        <div
            v-if="selectedResult"
            class="selected"
            :class="{
                disabled: disabled
            }"
        >
            <div 
                v-if="selectedResult.ajuste_id"
                v-b-tooltip.hover.noninteractive="{ boundary: 'window' }"
                :title="onTitlesSelectedFormatter(selectedResult)" 
                v-html="selectedResult.nome_produto" 
            />
            <div
                v-else
                v-b-tooltip.hover.noninteractive="{ boundary: 'window' }"
                :title="onTitlesSelectedFormatter(selectedResult)" 
                v-html="onResultsSelectedFormatter(selectedResult)" 
            />
            <i 
                v-if="view && viewPermission" 
                class="glyphicon glyphicon-search" 
                @click="onView()" 
            />
            <i 
                class="glyphicon glyphicon-trash" 
                @click="onClear()" 
                v-b-tooltip.hover 
                title="Limpar" 
                />
        </div>
        <ul
            v-show="
                show &&
                ((results.length > 0 && value.length >= minChars) ||
                    (showNoResultsText && value.length >= minChars && loading == false) ||
                    (showSearchingText && loading == true))
            "
            :class="[
                {
                    'w-100': !showOverflow
                },
                {
                    results: results.length > 0
                }
            ]"
        >
            <template v-if="results.length">
                <li
                    v-for="(result, i) in results"
                    :key="i"
                    :ref="'result_' + i"
                    :class="arrowCounter == i ? 'active' : ''"
                    @mouseover="setArrowCounter(i)"
                    @mousedown="onSelect()"
                    v-html="onResultsFormatter(result)"
                ></li>
            </template>
            <template v-else>
                <li v-if="value.length < minChars && loading == false && showMinCharsText == true">
                    {{ minCharsText.replace('{minChars}', minChars) }}
                </li>
                <li v-if="loading == true">
                    {{ searchingText }}
                </li>
                <li v-if="value.length >= minChars && loading == false">
                    {{ noResultsText }}
                </li>
            </template>
            <template v-if="(!isModal && add && addPermission && loading == false) || (forceIsModal && add && addPermission && loading == false)">
                <li class="new-register">
                    <button type="button" class="btn btn-success" :class="`botao-${size}`" @click.prevent="onRegister()">
                        <i class="fa fa-plus"></i>
                        {{ addText }}
                    </button>
                </li>
            </template>
        </ul>
    </div>
</template>
<script>
const Cache = function () {
    let data = {}
    let size = 0
    let flush = function () {
        data = {}
        size = 0
    }
    this.add = function (query, results) {
        if (size > 500) {
            flush()
        }
        if (!data[query]) {
            size += 1
        }
        data[query] = results
    }
    this.get = function (query) {
        return data[query]
    }
    this.clear = function () {
        data = {}
    }
}
const cache = new Cache()

import _ from 'lodash'
import { isMobile } from '../../common/functions/interface'
export default {
    props: {
        id: {
            type: String,
            default: 'id' + Math.random(10, 1000)
        },
        disabled: {
            type: Boolean,
            default: false
        },
        minChars: {
            type: Number,
            default: 0
        },
        method: {
            type: String,
            default: 'get'
        },
        queryParam: {
            type: String,
            default: 'q'
        },
        items: {
            type: Array,
            default: () => []
        },
        url: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: 'nome'
        },
        placeholder: {
            type: String,
            default: 'Digite para buscar'
        },
        default: {
            type: Object,
            default: null
        },
        minCharsText: {
            type: String,
            default: 'Digite no mínimo {minChars} caracteres'
        },
        showMinCharsText: {
            type: Boolean,
            default: true
        },
        noResultsText: {
            type: String,
            default: 'Nenhum resultado encontrado'
        },
        showNoResultsText: {
            default: true
        },
        searchingText: {
            default: 'Buscando...'
        },
        showSearchingText: {
            default: true
        },
        selectOnBlur: {
            default: false
        },
        resetKeywordEnabled: {
            default: true
        },
        emitResetKeywordEnabled: {
            default: true
        },
        add: {
            type: Function,
            default: null
        },
        addPermission: {
            default: true
        },
        addText: {
            type: String,
            default: 'Adicionar novo'
        },
        size: {
            type: String,
            default: 'md'
        },
        view: {
            type: Function,
            default: null
        },
        viewPermission: {
            default: true
        },
        resultsFormatter: {
            type: Function,
            default: (result, vm) => {
                return result[vm.label]
            }
        },
        resultsSelectedFormatter: {
            type: Function,
            default: (result, vm) => {
                return result[vm.label]
            }
        },
        titlesSelectedFormatter: {
            type: Function,
            default: (result, vm) => {
                return result[vm.label]
            }
        },
        showOverflow: {
            default: false
        },
        callbackOnClear: {
            type: Function,
            default: null
        },
        forceIsModal: {
            default: false
        },
    },
    inject: {
        isModal: {
            default: false
        }
    },
    data() {
        return {
            value: '',
            show: false,
            arrowCounter: 0,
            results: [],
            loading: false,
            selectedResult: null,
            input: null,
            autoAdd: false
        }
    },
    watch: {
        selectedResult(value) {
            this.input.disabled = value !== null
        }
    },
    mounted() {
        this.input = this.$refs.autocomplete.querySelector('input')
        this.input.addEventListener('keydown', (e) => {
            this.onKeydown(e)
        })
        this.input.addEventListener('focus', (e) => {
            cache.clear()
            this.resetKeyword()
            this.onSearch(e)
        })
        this.input.addEventListener('keyup', (e) => {
            if(e.key ==  'Enter'){
                this.autoAdd = true
            }
            this.onSearch(e)
        })
        window.addEventListener('click', (e) => {
            if (this.show && e.target.id != this.input.id) {
                if (this.selectOnBlur) {
                    this.onSelectBlur()
                } else {
                    this.onBlur()
                }
            }
        })
        if (this.input.getAttribute('placeholder') == null) {
            this.input.setAttribute('placeholder', this.placeholder)
        }
        if (this.default) {
            this.selectedResult = this.default
            this.emitInput()
        }
        if (this.input.value) {
            this.input.setAttribute('tabindex', '-1')
        }
    },
    methods: {
        onSearch(e) {
            if (this.selectedResult) {
                return false
            }

            this.value = e.target.value
            if (!this.showMinCharsText && this.minChars > this.value.length) {
                return false
            }
            this.show = true
            const notKeys = ['ArrowDown', 'ArrowUp', 'Enter', 'Esc']
            if (notKeys.includes(e.key)) {
                return false
            }
            if (this.minChars > this.value.length) {
                return false
            }
            this.loading = true
            this.results = []
            if (this.items && this.items.length > 0) {
                this.results = this.items.filter(item => {
                    return item[this.label].toString().toLowerCase().includes(this.value.toLowerCase());
                });
                this.loading = false;
                this.$emit('onResults', this.results);
            } else {
                this.search(this.value, this);
            }
            if (this.showOverflow && isMobile()) {
                const lista = this.$refs.autocomplete.querySelector('ul')
                lista.style.left = 0
                lista.style.right = 0
                lista.style.width = window.innerWidth - 40 + 'px'
            }
        },
        search: _.debounce((search, vm) => {
            const key = vm.url + vm.queryParam + search
            const c = cache.get(key)
            if (c) {
                vm.results = c
                vm.loading = false
                vm.$emit('onResults', c)
            } else {
                vm.$api[vm.method](
                    vm.url,
                    {
                        [vm.queryParam]: search
                    },
                    false
                ).then((res) => {
                    vm.results = res.data
                    if(vm.results.length == 1 && vm.autoAdd){
                        vm.selectedResult = vm.results[0]
                        vm.emitInput()
                        vm.onBlur()
                        vm.autoAdd = false
                    }
                    vm.loading = false
                    cache.add(key, res.data)
                    vm.$emit('onResults', res.data)
                })
            }
        }, 600),
        onBlur() {
            this.show = false
            setTimeout(() => {
                this.resetOptions()
                this.resetArrowCounter()
                this.resetKeyword()
            }, 200)
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter -= 1
                this.fixScrolling()
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length - 1) {
                this.arrowCounter += 1
                this.fixScrolling()
            }
        },
        onSelect() {
            this.selectedResult = this.results[this.arrowCounter]
            this.emitInput()
            this.onBlur()
        },
        onSelectBlur() {
            setTimeout(() => {
                this.show = false
                if (!this.selectedResult && this.input.value) {
                    this.selectedResult = {
                        [this.label]: this.input.value
                    }
                    this.emitInput()
                }
                this.resetArrowCounter()
                this.resetKeyword()
            }, 200)
        },
        onClear() {
            if(this.callbackOnClear && typeof(this.callbackOnClear) === 'function'){
                this.callbackOnClear()
            }else{
                this.onClearConfirm()
            }
        },
        onClearConfirm(){
            if (!this.disabled) {
                this.resetSelectedResult()
                this.resetOptions()
                this.resetKeyword()
                this.emitInput()
            } 
        },
        onRegister() {
            this.add(this.input.value)
            this.results = []
            cache.clear()
            this.onBlur()
            return false
        },
        onView() {
            this.view()
        },
        emitInput() {
            this.$emit('result', this.selectedResult)
            if (this.selectedResult) {
                this.$emit('selected', this.selectedResult)
            } else {
                this.$emit('deleted', this.selectedResult)
            }
        },
        resetSelectedResult() {
            this.value = ''
            this.show = false
            this.selectedResult = null
            this.resetOptions()
        },
        resetKeyword() {
            if (this.resetKeywordEnabled) {
                if(
                    this.emitResetKeywordEnabled
                    &&
                    this.input.value != ''
                ){
                    this.emitInput()
                }
                this.input.value = ''
            }
        },
        resetOptions() {
            this.results = []
        },
        setArrowCounter(number) {
            this.arrowCounter = number
        },
        fixScrolling() {
            this.$refs['result_' + this.arrowCounter][0].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            })
        },
        resetArrowCounter() {
            this.arrowCounter = 0
        },
        onKeydown(e) {
            switch (e.code) {
                case 'ArrowDown':
                    e.preventDefault()
                    this.onArrowDown()
                    break
                case 'ArrowUp':
                    e.preventDefault()
                    this.onArrowUp()
                    break
                case 'Enter':
                    e.preventDefault()
                    if (this.results.length) {
                        this.onSelect()
                    }
                    break
                case 'NumpadEnter':
                    e.preventDefault()
                    if (this.results.length) {
                        this.onSelect()
                    }
                    break
                case 'Escape':
                    this.onBlur()
                    break
                case 'Tab':
                    if (this.results.length) {
                        this.onSelect()
                    }
                    if (this.selectOnBlur) {
                        this.onSelectBlur()
                    } else {
                        this.onBlur()
                    }
                    break
            }
        },
        onResultsFormatter(result) {
            return this.resultsFormatter(result, this)
        },
        onResultsSelectedFormatter(result) {
            return this.resultsSelectedFormatter(result, this)
        },
        onTitlesSelectedFormatter(result) {
            return this.titlesSelectedFormatter(result, this)
        }
    }
}
</script>
<style>
.autocomplete ul {
    position: absolute;
    min-width: 160px;
    max-width: 100%;
    max-height: 300px;
    overflow: auto;
    min-width: 10rem;
    padding: 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    z-index: 1100;
    -webkit-backface-visibility: hidden;
}
/* small */
.autocomplete-sm ul {
    font-size: 0.875rem;
}
/* large */
.autocomplete-lg ul {
    font-size: 1.25rem;
}
.autocomplete ul li:nth-child(even) {
    background-color: #f2f2f2;
}
.autocomplete ul li {
    display: block;
    width: 100%;
    padding: 5px 10px 5px 10px;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    background-color: transparent;
    border: 0;
}
.autocomplete ul.results li {
    cursor: pointer;
}
.autocomplete ul.results li:hover,
.autocomplete ul.results li.active {
    color: #fff;
    text-decoration: none;
    background-color: #007bff;
}
.autocomplete ul li.new-register {
    position: sticky;
    bottom: 0;
    background-color: #fff;
    padding: 0;
}
.autocomplete ul li.new-register button {
    width: 100%;
    border-radius: 0;
}
.autocomplete .selected {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
/* large */
.autocomplete-lg .selected {
    height: calc(1.5em + 1rem + 2px);
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
}
/* small */
.autocomplete-sm .selected {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}
.autocomplete .selected div {
    overflow: hidden;
    white-space: nowrap;
    height: 100%;
}
.autocomplete .selected i {
    top: 8px;
    position: absolute;
    cursor: pointer;
    background-color: #fff;
}
.autocomplete-sm .selected i {
    top: 6px;
}
.autocomplete-lg .selected i {
    top: 12px;
}
.autocomplete .selected i.glyphicon-trash {
    right: 10px;
}
.autocomplete .selected i.glyphicon-search {
    right: 30px;
}
.autocomplete .selected.disabled {
    background-color: #e9ecef;
    opacity: 1;
}
.autocomplete .selected.disabled i {
    background-color: #e9ecef;
}

.autocomplete input:disabled.error {
    border-color: #ced4da !important;
}
.autocomplete-sm input {
    font-size: 0.875rem;
}
.autocomplete-lg input {
    font-size: 1.25rem;
}
/* .autocomplete input:disabled {
    background-color: #fff !important;
} */

 .botao-sm {
    font-size: 0.875rem;
 }
 .botao-lg {
    font-size: 1.25rem;
 }
</style>
